import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0d6efd', // Blue color from the image
      light: '#4d94ff',
      dark: '#0048c9',
    },
    secondary: {
      main: '#fd7e14', // Orange color from the image
      light: '#ffae52',
      dark: '#c55000',
    },
    success: {
      main: '#198754', // Green color from the image
      light: '#4cb17f',
      dark: '#005f2c',
    },
    error: {
      main: '#dc3545', // Red color from the image
      light: '#ff6b70',
      dark: '#a3001e',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#212529',
      secondary: '#6c757d',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h3: {
      fontWeight: 700,
      fontSize: '2rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
      color: '#6c757d',
    },
    body2: {
      fontSize: '0.875rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
